import { MentorsModel } from '@models'
import Button from '@/components/atoms/Button'
import { useAppDispatch } from '@/store/hooks'
import { modalCreators } from '@/store/ducks/modal'
import { usePlanValidation } from '@/utils/hooks/usePlanValidation'

interface CardMentorProps {
	isLoading?: boolean
	className?: string
	onClick?: () => void
}

export function CardSession({
	infoSession,
	className,
	onClick,
	isLoading,
}: {
	infoSession: {
		title: string
		duration: 15 | 30 | 60
		subtitle: string
		vertical: string
		tag?: 'DESCONHECIDO' | 'EMPREENDA'
		dataMentor?: MentorsModel.GetMentor
		isMentorshipAwari?: boolean
	}
} & CardMentorProps) {
	const dispatch = useAppDispatch()
	const { validationPlan } = usePlanValidation()

	return (
		<div className='flex flex-col w-full bg-zinc-900 hover:bg-zinc-900/80 transition-colors duration-300 rounded-lg dark:hover:bg-opacity-90 shadow-box p-6 cursor-pointer'>
			<div className='flex flex-col gap-6 justify-between h-full'>
				<div className='flex flex-col gap-4'>
					<span className='text-sm leading-[155%] text-white/70 font-medium'>
						{infoSession.title}
					</span>
					<p className='text-2xl font-medium text-white leading-[104%]'>
						{infoSession.duration === 60
							? `1 hora`
							: `${infoSession.duration || 30}
						min`}
					</p>
					<p className='text-base leading-[155%] text-white/70'>
						{infoSession.subtitle}
					</p>
				</div>
				<Button
					className='h-[38px] font-medium rounded-full'
					onClick={() => {
						validationPlan({
							messageCredits:
								'Você precisa ter créditos para realizar sessões de mentorias.',
						})

						if (
							!infoSession?.dataMentor?.calendar[infoSession?.duration || 30]
								?.length
						) {
							dispatch(
								modalCreators.openModal({
									name: 'statusModal',
									type: 'error',
									modalInfo: {
										title: 'Mentor indisponível',
										buttonLabel: 'Fechar',
										message:
											'Esse mentor não possui horário disponível, por favor, atualize a página e selecione outro.',
									},
								})
							)
						}

						dispatch(
							modalCreators.openModal({
								name: 'scheduleMentorshipModal',
								modalInfo: {
									currentSessionDuration: infoSession.duration || 30,
									...infoSession.dataMentor,
								},
							})
						)
					}}
				>
					Agendar
				</Button>
			</div>
		</div>
	)
}
